export const LiveJournal = ({
  width = '14',
  height = '13',
  color = 'white',
}) => {
  return (
    <svg
      fill={color}
      height={height}
      width={width}
      version="1.1"
      id="Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      viewBox="0 0 304.999 304.999"
      xmlSpace="preserve"
    >
      <g id="XMLID_16_">
        <path
          id="XMLID_17_"
          d="M160.662,19.47c-18.934,0-37.323,3.668-54.693,10.881L76.353,0.732c-0.819-0.82-2.094-0.967-3.082-0.359
            C44.436,18.201,19.773,42.865,1.947,71.699c-0.61,0.986-0.462,2.262,0.358,3.082l28.39,28.383
            c-8.491,18.637-12.808,38.5-12.808,59.074c0,78.719,64.049,142.762,142.775,142.762c78.721,0,142.765-64.043,142.765-142.762
            C303.427,83.515,239.383,19.47,160.662,19.47z M217.225,148.664l9.943,42.082l9.543,44.395l-44.337-9.533l-42.055-9.893
            L36.712,102.111c14.252-29.338,38.339-52.619,68.114-65.832L217.225,148.664z"
        />
        <path
          id="XMLID_20_"
          d="M221.76,187.396l-7.522-33.023c-25.891,11.889-46.404,32.402-58.283,58.295l33.023,7.52
            C195.989,206.165,207.747,194.41,221.76,187.396z"
        />
      </g>
    </svg>
  );
};
